// extracted by mini-css-extract-plugin
export var buttonsContainer = "AddressForm_buttonsContainer__Yued5";
export var editForm = "AddressForm_editForm__8R7Xs";
export var editInnerContainer = "AddressForm_editInnerContainer__6wv0f";
export var header = "AddressForm_header__zyw1s";
export var inputContainer = "AddressForm_inputContainer__oA5ji";
export var lg = "992px";
export var md = "768px";
export var phoneNumber = "AddressForm_phoneNumber__nIhQL";
export var readOnlyFields = "AddressForm_readOnlyFields__jyECz";
export var readOnlySection = "AddressForm_readOnlySection__I58lY";
export var shared = "\"../shared.module.css\"";